module.exports = __webpack_public_path__ + "media/assets/plane-2-color-d79d3cdfe2ec39e22a95697247ad30cb.svg";